import React from "react";
import PropTypes from "prop-types";
import ConfirmModal from "../confirm-modal/ConfirmModal";
import LoaderModal from "../loader-modal/LoaderModal";

const TabularViewModals = ({
  showConfirmSave,
  onCloseConfirmSave,
  onConfirmSave,
  showConfirmNavigation,
  onCloseConfirmNavigation,
  onConfirmNavigation,
  showLoader,
  setShowLoader,
  headerMessage,
  loaderDesc,
}) => {
  return (
    <>
      <ConfirmModal
        show={showConfirmSave}
        onClose={onCloseConfirmSave}
        onConfirm={onConfirmSave}
      />
      <ConfirmModal
        show={showConfirmNavigation}
        onClose={onCloseConfirmNavigation}
        onConfirm={onConfirmNavigation}
        title="Your changes have not been saved"
        message="The updates you made on this tab will be lost. Are you sure you want to leave without saving?"
        confirmText="Yes, that's fine"
      />
      <LoaderModal
        showLoader={showLoader}
        setShowLoader={setShowLoader}
        {...(headerMessage !== undefined && { headerMessage })}
        {...(loaderDesc !== undefined && { description: loaderDesc })}
      />
    </>
  );
};

TabularViewModals.propTypes = {
  showConfirmSave: PropTypes.bool.isRequired,
  onCloseConfirmSave: PropTypes.func.isRequired,
  onConfirmSave: PropTypes.func.isRequired,
  showConfirmNavigation: PropTypes.bool.isRequired,
  onCloseConfirmNavigation: PropTypes.func.isRequired,
  onConfirmNavigation: PropTypes.func.isRequired,
  showLoader: PropTypes.bool.isRequired,
  setShowLoader: PropTypes.func.isRequired,
  headerMessage: PropTypes.string,
  loaderDesc: PropTypes.string,
};

export default TabularViewModals;
